export default {
  categoryInfo: [],
  categorySlugOptions: [],
  categorySlugOptionsSearch: "",
  previewUrl: "",
  page: 0,
  search: "",
  existCategories: [],
  categoryAllAttributes: {},
  categoryInstance: {},
  error: "",
  success: "",
  loading: {
    mainLoading: false, // main loading for the whole system
    pageLoading: false, // loading animation just for category page
    createLoading: false, // loading animation for save button on create page
    updateLoading: false // loading animation for save button on update page
  },
  operation: "create"
};
